<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="管线名称"
                prop="pipelineName"
              >
                <a-input
                  v-model="queryParam.pipelineName"
                  placeholder="请输入管线名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="所属客户"
                prop="customUserId"
                v-if="!customUserId"
              >
                <a-select
                  v-model="queryParam.customUserId"
                  placeholder="请选择所属客户"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in customList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.companyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 8 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['saifuneng:pipeline:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <publicPage ref="public"></publicPage>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span
          slot="pipelineColor"
          slot-scope="text, record"
        >
          <a-tag :color="record.pipelineColor">{{ record.pipelineColor }}</a-tag>
        </span>
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="deviceCount"
          slot-scope="text, record"
        >
          <a @click="$refs.public.handleAdd(record.id, 2, 2)"> {{ record.deviceCount }}</a>
        </span>
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['saifuneng:pipeline:edit']"
          >
            <a-icon type="edit" />修改
          </a>
          <a-divider
            type="vertical"
            v-hasPermi="['saifuneng:pipeline:remove']"
          />
          <a
            @click="handleDelete(record)"
            v-hasPermi="['saifuneng:pipeline:remove']"
          >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePipeline, delPipeline, userPage } from '@/api/saifuneng/pipeline'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import publicPage from '../../public.vue'

export default {
  name: 'User',
  components: {
    CreateForm,
    publicPage
  },
  props: ['customUserId'],
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      customList: [],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pipelineName: null,
        customUserId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '管线名称',
          dataIndex: 'pipelineName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '管线颜色',
          dataIndex: 'pipelineColor',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'pipelineColor' }
        },
        {
          title: '公司名称',
          dataIndex: 'customUserCompanyName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '里程范围',
          dataIndex: 'mileageRange',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '位置信息',
          dataIndex: 'address',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备数量',
          dataIndex: 'deviceCount',
          scopedSlots: { customRender: 'deviceCount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    if (this.customUserId) {
      this.queryParam.customUserId = this.customUserId
      // this.columns.pop()
    }
    this.getList()
    this.getCustomList(null)
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pagePipeline(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userName: undefined,
        companyName: undefined,
        companyAddress: undefined,
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.queryParam.customUserId = this.customUserId
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中管线名称为【' + row.pipelineName + '】的数据',
        onOk () {
          return delPipeline({ "id": row.id })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.id = {}
        }
      })
    },
    getCustomList () {
      let query = {
        pageNum: 1,
        pageSize: 9999,
        userType: '04'
      }
      userPage(query).then(response => {
        console.log(response, 'response===========');
        this.customList = response.data.records
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }

  }
}
</script>
